import { Mic, TrendingUp } from "lucide-react";
import ProductPage from "@/components/ProductPage";
import InsightsRequestForm from "@/components/InsightsRequestForm";
import {
  useDocumentTitle,
  DEFAULT_STEPS,
} from "@/lib/shared";

const FEATURES = [
  {
    Icon: Mic,
    title: "Grabación Unificada",
    desc: "Capturamos llamadas con clientes externos (PSTN) y conversaciones internas entre colaboradores.",
  },
  {
    Icon: TrendingUp,
    title: "Análisis de Sentimiento",
    desc: "Detectamos emociones y palabras clave para mejorar la calidad y asegurar el cumplimiento legal.",
  },
];

const InsightsPage = () => {
  useDocumentTitle("Caruna Insights — Grabación y Analítica");
  return (
    <>
      <ProductPage
        category="insights"
        eyebrow="GRABACIÓN Y ANALÍTICA"
        headline="Caruna Insights"
        subhead="Captura el valor de cada conversación, interna o externa."
        features={FEATURES}
        steps={DEFAULT_STEPS}
        integrations={["Microsoft Teams"]}
        ctaHeadline="Solicita una evaluación técnica de Caruna Insights"
        baseTech="Interaction Insights"
        heroBody="Caruna Insights captura y analiza cada conversación relevante de tu operación: grabación unificada de llamadas externas (PSTN) e internas entre colaboradores, más análisis de sentimiento y palabras clave para asegurar la calidad y el cumplimiento legal."
      />
      <InsightsRequestForm />
    </>
  );
};

export default InsightsPage;
